<div>
  <div class="flex justify-content-between align-items-center mb-4">
    <h2 class="m-0">Histórico de Integridade</h2>
    <div class="filters-row">
      <p-dropdown 
        [options]="months" 
        [(ngModel)]="selectedMonth" 
        (onChange)="onMonthChange()" 
        optionLabel="label" 
        optionValue="value"
        placeholder="Mês (Todos)">
      </p-dropdown>

      <p-dropdown 
        [options]="years" 
        [(ngModel)]="selectedYear" 
        (onChange)="onYearChange()" 
        optionLabel="label" 
        optionValue="value"
        placeholder="Selecione o Ano">
      </p-dropdown>
    </div>
  </div>

  <div *ngIf="loading" class="flex justify-content-center">
    <p-progressSpinner></p-progressSpinner>
  </div>

  <div *ngIf="!loading && hasData">
    <p-chart type="line" [data]="data" [options]="options" height="60vh"></p-chart>
  </div>

  <div *ngIf="!loading && !hasData" class="flex flex-column align-items-center justify-content-center p-5 text-center surface-ground border-round">
    <i class="pi pi-inbox text-5xl text-500 mb-3"></i>
    <span class="text-xl text-500 font-medium">Nenhum dado encontrado para o ano de {{selectedYear}}.</span>
  </div>

  <div *ngIf="!loading && hasData" class="mt-4">
    <p-table [value]="tableData" [rows]="10" [paginator]="true" responsiveLayout="scroll" styleClass="p-datatable-sm">
      <ng-template pTemplate="header">
        <tr>
          <th>Integridade</th>
          <th class="text-center">Pico no Período</th>
          <th class="text-center">Média Estabilidade</th>
          <th class="text-center">Tendência</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr>
          <td>
            <span [style.color]="item.color || '#36A2EB'" class="font-bold mr-2">●</span>
            {{item.name}}
          </td>
          <td class="text-center font-bold">{{item.peak}}</td>
          <td class="text-center">{{item.stability | number:'1.2-2'}}</td>
          <td class="text-center">
            <i *ngIf="item.trend === 'up'" class="pi pi-arrow-up text-red-500 font-bold" pTooltip="Aumento de erros"></i>
            <i *ngIf="item.trend === 'down'" class="pi pi-arrow-down text-green-500 font-bold" pTooltip="Redução de erros"></i>
            <i *ngIf="item.trend === 'stable'" class="pi pi-minus text-500" pTooltip="Estável"></i>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
